import { Trans } from '@lingui/react/macro';
import { Menu } from '@pocketlaw/tetris';
import { MenuFooter } from './MenuFooter';
export function BooleanMenu(props) {
    const { property, initialValue, onChange, onClear } = props;
    const { label } = property;
    const handleYes = () => {
        onChange(property, true);
    };
    const handleNo = () => {
        onChange(property, false);
    };
    const handleClear = () => {
        onClear(property);
    };
    return (<Menu.ItemNested target={label}>
      <Menu.Item selected={initialValue === true} onClick={handleYes}>
        <Trans comment="Bulk action: Metadata - Boolean menu - Yes">Yes</Trans>
      </Menu.Item>
      <Menu.Item selected={initialValue === false} onClick={handleNo}>
        <Trans comment="Bulk action: Metadata - Boolean menu - No">No</Trans>
      </Menu.Item>
      <MenuFooter onClear={handleClear}/>
    </Menu.ItemNested>);
}
